export default __webpack_public_path__ + "static/media/client4.510f2f01.jpg";